import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["colspan"]
const _hoisted_2 = { class: "form-group form-check custom-checkbox mt-2" }
const _hoisted_3 = ["checked"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-1 pb-2",
  for: "payable"
}, null, -1 /* HOISTED */)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("i", null, " No Actions ")
], -1 /* HOISTED */)
const _hoisted_7 = {
  key: 0,
  class: "button-cell text-end"
}
const _hoisted_8 = {
  key: 1,
  class: "button-cell text-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(`${_ctx.isEditRequested || _ctx.isAddRequested ? 'edit-row' : ''}`)
  }, [
    _createElementVNode("td", {
      colspan: `${_ctx.isEditRequested || _ctx.isAddRequested ? '2' : '1'}`,
      class: "align-top"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("input", {
          type: "checkbox",
          id: "payable",
          class: "form-check-input",
          checked: _ctx.detail.isPayable,
          disabled: ""
        }, null, 8 /* PROPS */, _hoisted_3),
        _hoisted_4
      ])
    ], 8 /* PROPS */, _hoisted_1),
    _createElementVNode("td", null, [
      _createVNode(_component_EmptyTextHandler, {
        text: _ctx.formatDate(_ctx.detail.startTime)
      }, null, 8 /* PROPS */, ["text"])
    ]),
    _createElementVNode("td", null, [
      _createVNode(_component_EmptyTextHandler, {
        text: _ctx.formatingDateOrTime(_ctx.detail.startTime, 'hh:mm A')
      }, null, 8 /* PROPS */, ["text"])
    ]),
    _createElementVNode("td", null, [
      _createVNode(_component_EmptyTextHandler, {
        text: _ctx.formatDate(_ctx.detail.endTime)
      }, null, 8 /* PROPS */, ["text"])
    ]),
    _createElementVNode("td", null, [
      _createVNode(_component_EmptyTextHandler, {
        text: _ctx.formatingDateOrTime(_ctx.detail.endTime, 'hh:mm A')
      }, null, 8 /* PROPS */, ["text"])
    ]),
    _createElementVNode("td", null, [
      _createVNode(_component_EmptyTextHandler, {
        text: _ctx.detail.units
      }, null, 8 /* PROPS */, ["text"])
    ]),
    _createElementVNode("td", null, [
      (_ctx.detail.rate)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "$"))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_EmptyTextHandler, {
        text: _ctx.detail.rate
      }, null, 8 /* PROPS */, ["text"])
    ]),
    _createElementVNode("td", null, [
      _createVNode(_component_EmptyTextHandler, {
        text: _ctx.detail.rateTypeText
      }, null, 8 /* PROPS */, ["text"])
    ]),
    _createElementVNode("td", null, [
      _createVNode(_component_EmptyTextHandler, {
        text: _ctx.detail.isPaid ? 'Yes' : 'No'
      }, null, 8 /* PROPS */, ["text"])
    ]),
    _hoisted_6,
    (_ctx.isEditRequested)
      ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-success",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveEditDetail()))
          }, "Add"),
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-secondary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelEditDetail()))
          }, " Cancel ")
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isAddRequested)
      ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-success",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save()))
          }, "Add"),
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-secondary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancelSaveNewDetail()))
          }, " Cancel ")
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}